export enum ELandingBenefitsAnimationDelay {
  TITLE = 0,
  LIST = 500,
}
